// AdminGeneralSettings.jsx
import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { fetchAllProjects } from "../../Controllers/projectController";
import { statuses } from "../helpers";
import "../../Styles/tables.css";

const ProjectConfirmation = () => {
  const [projects, setProjects] = useState([]);

  const getProjects = async () => {
    await fetchAllProjects(
      "updatedAt",
      "DESC",
      "DESC",
      "DESC",
      false,
      false,
      100,
      1,
      null,
      null,
      null,
      null,
      setProjects,
      () => {},
      false,
      [
        {
          key: "status_id",
          label: "Status",
          value: statuses.WAITING_FOR_ACCOUNTING_SIGNOFF,
        },
      ],
      [],
    );
  };

  useEffect(() => {
    getProjects();
  }, []);

  const columnTemplate = `10% 20% 15% 15% 15% 10%`;
  const renderHeader = () => (
    <Box
      className="table-head"
      display="grid"
      gridTemplateColumns={columnTemplate}
      px={4}
      pl={{ xs: 2, md: 4 }}
      py={1}
      sx={{
        backgroundColor: (t) => t.palette.primary.main, //"#041e41",
        color: (t) => t.palette.text.main,
        fontWeight: "bold",
      }}
    >
      {["Acronym", "Name", "Manager", "Unit", "Status", "Actions"].map(
        (label, idx) => (
          <Box
            key={idx}
            display="flex"
            alignItems="center"
            gap={1}
            pr={2}
            flexWrap={"wrap"}
          >
            <Typography variant="body1" fontWeight="bold">
              {label}
            </Typography>
          </Box>
        ),
      )}
    </Box>
  );

  const renderRow = (project) => (
    <Box
      key={project.uid}
      display="grid"
      gridTemplateColumns={columnTemplate}
      px={4}
      pl={{ xs: 2, md: 4 }}
      py={1}
      sx={{
        alignItems: "flex-start",
        wordBreak: "break-word",
        borderBottom: "1px solid #ddd",
      }}
    >
      <Typography variant="body1" pr={2}>
        {project.acronym || "-"}
      </Typography>
      <Typography variant="body1" pr={2}>
        {project.name || "-"}
      </Typography>
      <Typography variant="body1" pr={2}>
        {project.project_manager_name || "-"}
      </Typography>
      <Typography variant="body1" pr={2}>
        {project.Unit.unit_name || "N/A"}
      </Typography>
      <Typography variant="body1" pr={2}>
        {project.Status.status_name || "N/A"}
      </Typography>
      <Box>
        <Button
          variant="contained"
          href={`/project/${project.uid}`}
          size="small"
        >
          View
        </Button>
      </Box>
    </Box>
  );

  return (
    <Box className="mainContainer">
      {renderHeader()}
      {projects?.map((p) => renderRow(p))}
    </Box>
  );
};

export default ProjectConfirmation;
